export default __webpack_public_path__ + "static/about-9f7f8ff8d2a4cb416c5f8ae8c9aeca37.jpeg";